<template>
    <div id="bar-echart2"></div>
  </template>
  
  <script>
  import echarts from "echarts";
  export default {
    data() {
      return {
        chart3: null
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
      window.addEventListener("resize", this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);   
      if (!this.chart3) {
        return
      }
      this.chart3.dispose()
      this.chart3 = null
    },
    methods: {
      initChart() {
        this.chart3 = echarts.init(document.getElementById("bar-echart2"));
        var data = { 
          area: ['公', '水', '学', '医', '职', '传', '放', '血液', '消','计生','爱'],
          legend: ['0~59分', '60~69分', '70~79分', '80~89分', '90~100分'],
          data: [
              [13, 15, 12, 16, 22, 2, 6, 8, 5,7,3],
              [13, 15, 12, 16, 22, 2, 6, 8, 5,7,3],
              [13, 15, 12, 16, 22, 2, 6, 8, 5,7,3],
              [13, 15, 12, 16, 22, 2, 6, 8, 5,7,3],
              [13, 15, 12, 16, 22, 2, 6, 8, 5,7,3],
          ]


          }
        let option = {
          color:['#185EFC','#3A96F5','#20C744','#FE783B','#F8DA3A'],
          grid: {
            top: 35,
            left: '5%',
            right: '5%',
            bottom: '20',
            containLabel: true
          },
          legend: {
            x: 'center',
            data: data.legend,
            icon:'rect',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              fontSize: 12,
              color: '#808080',
              padding: [0, 8, 0, 0]
            },
          },
          tooltip: {
          trigger: "axis",
          axisPointer: {
              type: "shadow",
              label: {
                  show: true
              }
          }
      },
        xAxis: {
          data: data.area,
          axisLine: {
              lineStyle: {
                  color: '#D7DFEC'
              }
          },
          axisLabel:{
            interval:0,
            color:'#333'
          },
          axisTick:{
            show: false,
          }, 
      },
      yAxis: [{
        name:'单位：件',
              type: "value",
            //   splitNumber: 4,
          splitLine: {
              lineStyle: {
                  type: 'solid',
                  color: '#F2F2F2'
              }
          },
          axisLine: {
              show: false,
              lineStyle: {
                color: '#ADC2D8'
              },
          },
          nameTextStyle: {
              color: '#808080'
          },
          splitArea: {
              show: false
          },
          axisTick:{
            show: false,
          },
        }
      ],
      series: []
        }
        for (var i = 0; i < data.legend.length; i++) {
            option.series.push({
                name: data.legend[i],
                type: 'bar',
                stack: '总量',
                barWidth: 18,
                label: {
                    show: false,
                    position: 'insideRight'
                },
                data: data.data[i]
            })
        }
        this.chart3.setOption(option)
      },
        resize(){
            if(this.chart3){
                this.chart3.resize();
            }
        }
    }
  }
  </script>

<style scoped>
#bar-echart2{ width: 100%; height: 100%;}
</style>
  